module.exports = __webpack_public_path__ + "img/222420Uv8ehmZr3mA1K9vm.c6724cc2.png";